import styled from 'styled-components';
import { Link } from 'gatsby';
import { calcResize } from 'components/Layout/styles';

export const SLink = styled(Link)`
  color: ${props =>
    props.isBlog ? (props.adCampaign ? '#335AA7' : null) : '#ffffff'};
  color: ${props => (props.adCampaign ? '#335AA7' : null)};
  padding-bottom: ${props => (props.adCampaign ? '30px' : null)};
  font-size: ${calcResize(12, 16)};
  /* max-width: 450px; */
  /* align-self: center; */
  display: inline-block;

  &:hover {
    color: ${props =>
      props.isBlog ? (props.adCampaign ? '#335AA7' : null) : '#ffffff'};
    color: ${props => (props.adCampaign ? '#335AA7' : null)};
  }

  &:not(:last-of-type) {
    &:after {
      content: ' / ';
      margin: 0 10px;
      text-decoration: none !important;
      pointer-events: none;
      display: inline-block;
    }
  }
`;
